export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6548.639835af.jpg";